export default "__VITE_ASSET__CmO99eVs__"